import './dom-53c9635b.js';
import { i as isArray } from './isArray-8eeb52b9.js';
import { i as isObject } from './isObject-4d5300e9.js';

/**
 * Determines whether `a` and `b` are the same value (makes shallow comparison of arrays and objects).
 */
const isEqual = (a, b) => {
  if (Object.is(a, b)) {
    return true;
  }
  if (isArray(a) && isArray(b)) {
    return a.length === b.length && a.every((item, index) => item === b[index]);
  }
  if (isObject(a) && isObject(b)) {
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return isEqual(aKeys, bKeys) && aKeys.every(key => a[key] === b[key]);
  }
  return false;
};

export { isEqual as i };
